import { Dialog, DialogActions, DialogContent, LinearProgress } from '@mui/material';
import React, { useEffect, useState } from 'react'

import { useAlert } from '../../../context/AlertContext';
import api from '../../../api/api'
import { AttachFile, AutoAwesome } from '@mui/icons-material';
import LabelValueJsonEditor from './LabelValueJsonEditor';

import pdfToText from "react-pdftotext";



function DocumentAttachment({documentId,callBack}) {
    const {AppAlert } = useAlert()
    const [dialogStatus,setDialogStatus] = useState("");
    const [savingInProgress,setSavingStatus] = useState("");
    
    const [selectedFile,setSelectedFile] = useState(null)
    const [fileTitle,setFileTitle] = useState("")
    const [remark,setRemark] = useState("");
    const [jsonData,setJsonData] = useState([]);

    const [uploadInProgress, setUploadProgress] = useState(null);

    const [objectUrl, setObjectUrl] = useState(null);

    const handleClose = () =>{
        setSelectedFile(null)
        setDialogStatus(false)
    }


    useEffect(() => {
    return () => {
        if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        }
    };
    }, [objectUrl]);
    
    
    const selectFile = (e) =>{
        if(e.target.files[0].type !=='application/pdf'){
            AppAlert("Invalid File Type","error");
            return false;
        }
        setSelectedFile(e.target.files[0])
        setObjectUrl(URL.createObjectURL(e.target.files[0]));
        
    }

    const uploadToServer = (formData) =>{
        api.post("/fms/document/attachment",formData,{
            onUploadProgress: (progressEvent) => { 
                const { loaded, total } = progressEvent;
                let percent = Math.floor((loaded * 100) / total);
                //console.log(percent);
                setUploadProgress(percent)
            },
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        }).then( (res)=>{
            AppAlert(res.data.msg)
            callBack();
        }).catch( (error) => {
            AppAlert(error.msg,"error")
            console.log(error);
        }).finally(()=>{
            setUploadProgress(null)
            handleClose();
        })
    }

    const onSubmit = () => {
        let formData = new FormData();
        formData.append('documentId',documentId);
        formData.append('tmpFile', selectedFile);
        formData.append('fileTitle', fileTitle);
        formData.append('remark', remark);
        
        let _jsonData = jsonData.filter(json=> json.label!=="" || json.value!=="" )
        formData.append('jsonData', JSON.stringify(_jsonData));
        uploadToServer(formData);
    }


    const readPDf = () =>{
        pdfToText(selectedFile).then((text) => setRemark(text)).catch((error) => console.error("Failed to extract text from pdf"))
    }

    return (
        <>
            <div className='btn btn-primary me-2' onClick={()=>setDialogStatus(true)} ><AttachFile /></div>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogContent>
                    
                    {selectedFile !== null && 
                        <div className='row'>
                            
                            <div className='col-md-6'>
                                <div className='text-center'>
                                    {
                                        /*
                                            <div className='d-md-none'>
                                                <embed className='img-fluid'  alt="preview file" src={URL.createObjectURL(selectedFile)} />
                                            </div>
                                        */
                                    }
                                    
                                    <div className=''>
                                        <object data={objectUrl} style={{width:500,height:600}} type="application/pdf" >
                                            <p>Your web browser doesn't have a PDF plugin. </p>
                                        </object>
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-6 mt-2'>
                                <div className="form-floating mb-3 ">
                                    <input type="text" className="form-control"  placeholder=""  value={fileTitle}  onChange={(e)=>setFileTitle(e.target.value)} />
                                    <label >Attachment Title * </label>
                                    
                                </div>

                                <div className=" mb-3 ">
                                    <label >Remark *  </label>
                                    <button className='btn btn-outline-success float-end mb-2' onClick={()=>readPDf()} > <AutoAwesome/> Read Text From File</button>
                                    <textarea  className="form-control"  placeholder=""  value={remark} onChange={(e)=>setRemark(e.target.value)} style={{height:300}} />
                                </div>

                                
                                <div>
                                    <LabelValueJsonEditor jsonData={jsonData} setJsonData={setJsonData} />
                                </div>
                            </div>
                            
                        </div>
                    }
                    {selectedFile == null &&
                        <div className="d-flex justify-content-center">
                            <div className="form-group">
                                <input type="file"
                                    className='d-none'
                                    onChange={ (e)=>{ selectFile(e) } } 
                                    accept=".pdf, .txt, .doc, .docx"
                                    id="uploadDocumentAttachment" 
                                />
                                <label for="uploadDocumentAttachment" className='btn btn-primary'>Select File</label>
                            </div>
                        </div>
                    }
                </DialogContent>
                <DialogActions>
                    {selectedFile!==null &&
                        <div className='row'>
                            <div className='col-md-12'>
                                {savingInProgress && <LinearProgress />}
                                {!savingInProgress &&
                                    <>
                                        <button className='btn btn-outline-primary me-2' onClick={handleClose} >Cancel</button>
                                        <button className='btn btn-primary' disabled={remark==="" || fileTitle === ""} onClick={onSubmit}>Upload</button>
                                    </>
                                }
                            </div>
                            
                        </div>
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DocumentAttachment